/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { OpfoelgningDto as OkEgisServiceModelsDtoOpfoelgningDto } from '../models/OK/Egis/Service/Models/DTO/opfoelgning-dto';
import { GetOpfoelgningerRequest as OkEgisServiceModelsRequestGetOpfoelgningerRequest } from '../models/OK/Egis/Service/Models/Request/get-opfoelgninger-request';
import { OpfoelgningRequest as OkEgisServiceModelsRequestOpfoelgningRequest } from '../models/OK/Egis/Service/Models/Request/opfoelgning-request';
import { ServiceordreOpfoelgningRequest as OkEgisServiceModelsRequestServiceordreOpfoelgningRequest } from '../models/OK/Egis/Service/Models/Request/serviceordre-opfoelgning-request';
import { TransferOpfoelgningerRequest as OkEgisServiceModelsRequestTransferOpfoelgningerRequest } from '../models/OK/Egis/Service/Models/Request/transfer-opfoelgninger-request';
import { GetServiceaftaleOpfoelgningerResponse as OkEgisServiceModelsResponseGetServiceaftaleOpfoelgningerResponse } from '../models/OK/Egis/Service/Models/Response/get-serviceaftale-opfoelgninger-response';
import { GetServiceordreOpfoelgningerResponse as OkEgisServiceModelsResponseGetServiceordreOpfoelgningerResponse } from '../models/OK/Egis/Service/Models/Response/get-serviceordre-opfoelgninger-response';
import { OpfoelgningCountResponse as OkEgisServiceModelsResponseOpfoelgningCountResponse } from '../models/OK/Egis/Service/Models/Response/opfoelgning-count-response';
import { OpfoelgningDashboardResponse as OkEgisServiceModelsResponseOpfoelgningDashboardResponse } from '../models/OK/Egis/Service/Models/Response/opfoelgning-dashboard-response';

@Injectable({
  providedIn: 'root',
})
export class OpfoelgningService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getServiceaftaleOpfoelgninger
   */
  static readonly GetServiceaftaleOpfoelgningerPath = '/api/v1/Opfoelgning/GetServiceaftaleOpfoelgninger';

  /**
   * GetServiceaftaleOpfoelgninger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceaftaleOpfoelgninger()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceaftaleOpfoelgninger$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetOpfoelgningerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftaleOpfoelgningerResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.GetServiceaftaleOpfoelgningerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftaleOpfoelgningerResponse>;
      })
    );
  }

  /**
   * GetServiceaftaleOpfoelgninger.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceaftaleOpfoelgninger$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceaftaleOpfoelgninger(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetOpfoelgningerRequest
  }): Observable<OkEgisServiceModelsResponseGetServiceaftaleOpfoelgningerResponse> {

    return this.getServiceaftaleOpfoelgninger$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftaleOpfoelgningerResponse>) => r.body as OkEgisServiceModelsResponseGetServiceaftaleOpfoelgningerResponse)
    );
  }

  /**
   * Path part for operation upsertServiceaftaleOpfoelgning
   */
  static readonly UpsertServiceaftaleOpfoelgningPath = '/api/v1/Opfoelgning/UpsertServiceaftaleOpfoelgning';

  /**
   * UpsertServiceaftaleOpfoelgning.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertServiceaftaleOpfoelgning()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertServiceaftaleOpfoelgning$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * OpfoelgningRequest
     */
    body?: OkEgisServiceModelsRequestOpfoelgningRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoOpfoelgningDto>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.UpsertServiceaftaleOpfoelgningPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoOpfoelgningDto>;
      })
    );
  }

  /**
   * UpsertServiceaftaleOpfoelgning.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `upsertServiceaftaleOpfoelgning$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertServiceaftaleOpfoelgning(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * OpfoelgningRequest
     */
    body?: OkEgisServiceModelsRequestOpfoelgningRequest
  }): Observable<OkEgisServiceModelsDtoOpfoelgningDto> {

    return this.upsertServiceaftaleOpfoelgning$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoOpfoelgningDto>) => r.body as OkEgisServiceModelsDtoOpfoelgningDto)
    );
  }

  /**
   * Path part for operation removeServiceaftaleOpfoelgning
   */
  static readonly RemoveServiceaftaleOpfoelgningPath = '/api/v1/Opfoelgning/RemoveServiceaftaleOpfoelgning';

  /**
   * RemoveServiceaftaleOpfoelgning.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeServiceaftaleOpfoelgning()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeServiceaftaleOpfoelgning$Response(params: {

    /**
     * id
     */
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.RemoveServiceaftaleOpfoelgningPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * RemoveServiceaftaleOpfoelgning.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeServiceaftaleOpfoelgning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeServiceaftaleOpfoelgning(params: {

    /**
     * id
     */
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.removeServiceaftaleOpfoelgning$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getServiceordreOpfoelgninger
   */
  static readonly GetServiceordreOpfoelgningerPath = '/api/v1/Opfoelgning/GetServiceordreOpfoelgninger';

  /**
   * GetServiceordreOpfoelgninger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceordreOpfoelgninger()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceordreOpfoelgninger$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetOpfoelgningerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceordreOpfoelgningerResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.GetServiceordreOpfoelgningerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceordreOpfoelgningerResponse>;
      })
    );
  }

  /**
   * GetServiceordreOpfoelgninger.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceordreOpfoelgninger$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceordreOpfoelgninger(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetOpfoelgningerRequest
  }): Observable<OkEgisServiceModelsResponseGetServiceordreOpfoelgningerResponse> {

    return this.getServiceordreOpfoelgninger$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceordreOpfoelgningerResponse>) => r.body as OkEgisServiceModelsResponseGetServiceordreOpfoelgningerResponse)
    );
  }

  /**
   * Path part for operation upsertServiceordreOpfoelgning
   */
  static readonly UpsertServiceordreOpfoelgningPath = '/api/v1/Opfoelgning/UpsertServiceordreOpfoelgning';

  /**
   * UpsertServiceordreOpfoelgning.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertServiceordreOpfoelgning()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertServiceordreOpfoelgning$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * OpfoelgningRequest
     */
    body?: OkEgisServiceModelsRequestServiceordreOpfoelgningRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoOpfoelgningDto>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.UpsertServiceordreOpfoelgningPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoOpfoelgningDto>;
      })
    );
  }

  /**
   * UpsertServiceordreOpfoelgning.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `upsertServiceordreOpfoelgning$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertServiceordreOpfoelgning(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * OpfoelgningRequest
     */
    body?: OkEgisServiceModelsRequestServiceordreOpfoelgningRequest
  }): Observable<OkEgisServiceModelsDtoOpfoelgningDto> {

    return this.upsertServiceordreOpfoelgning$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoOpfoelgningDto>) => r.body as OkEgisServiceModelsDtoOpfoelgningDto)
    );
  }

  /**
   * Path part for operation removeServiceordreOpfoelgning
   */
  static readonly RemoveServiceordreOpfoelgningPath = '/api/v1/Opfoelgning/RemoveServiceordreOpfoelgning';

  /**
   * RemoveServiceordreOpfoelgning.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeServiceordreOpfoelgning()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeServiceordreOpfoelgning$Response(params: {

    /**
     * id
     */
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.RemoveServiceordreOpfoelgningPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * RemoveServiceordreOpfoelgning.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeServiceordreOpfoelgning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeServiceordreOpfoelgning(params: {

    /**
     * id
     */
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.removeServiceordreOpfoelgning$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getOpfoelgningCountsForCurrentUser
   */
  static readonly GetOpfoelgningCountsForCurrentUserPath = '/api/v1/Opfoelgning/GetOpfoelgningCountsForCurrentUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOpfoelgningCountsForCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpfoelgningCountsForCurrentUser$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseOpfoelgningCountResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.GetOpfoelgningCountsForCurrentUserPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseOpfoelgningCountResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOpfoelgningCountsForCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpfoelgningCountsForCurrentUser(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseOpfoelgningCountResponse> {

    return this.getOpfoelgningCountsForCurrentUser$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseOpfoelgningCountResponse>) => r.body as OkEgisServiceModelsResponseOpfoelgningCountResponse)
    );
  }

  /**
   * Path part for operation getOpfoelgningDashboard
   */
  static readonly GetOpfoelgningDashboardPath = '/api/v1/Opfoelgning/GetOpfoelgningDashboard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOpfoelgningDashboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpfoelgningDashboard$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseOpfoelgningDashboardResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.GetOpfoelgningDashboardPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseOpfoelgningDashboardResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOpfoelgningDashboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpfoelgningDashboard(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseOpfoelgningDashboardResponse> {

    return this.getOpfoelgningDashboard$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseOpfoelgningDashboardResponse>) => r.body as OkEgisServiceModelsResponseOpfoelgningDashboardResponse)
    );
  }

  /**
   * Path part for operation getUsers
   */
  static readonly GetUsersPath = '/api/v1/Opfoelgning/GetUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.GetUsersPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<string>> {

    return this.getUsers$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation transferOpfoelgninger
   */
  static readonly TransferOpfoelgningerPath = '/api/v1/Opfoelgning/TransferOpfoelgninger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transferOpfoelgninger()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferOpfoelgninger$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestTransferOpfoelgningerRequest
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, OpfoelgningService.TransferOpfoelgningerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transferOpfoelgninger$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferOpfoelgninger(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestTransferOpfoelgningerRequest
  }): Observable<Array<string>> {

    return this.transferOpfoelgninger$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

}
